/* tslint:disable */
/* eslint-disable */
/**
 * az-ds-signroom
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.10-RELEASE 2022-08-03T12:08:13Z
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Bundle
 */
export interface Bundle {
    /**
     * 
     * @type {IProcessType}
     * @memberof Bundle
     */
    'processType': IProcessType;
    /**
     * Bundle name. This is the name of the envelope shown on eSaw.
     * @type {string}
     * @memberof Bundle
     */
    'name': string;
    /**
     * Bundle source system or flow
     * @type {string}
     * @memberof Bundle
     */
    'source'?: string;
    /**
     * bundle external id, used as reference key for caller systems
     * @type {string}
     * @memberof Bundle
     */
    'externalId'?: string;
    /**
     * documents to sign
     * @type {Set<Document>}
     * @memberof Bundle
     */
    'documents': Set<Document>;
    /**
     * Recipients involved in sign process
     * @type {Set<Recipient>}
     * @memberof Bundle
     */
    'recipients': Set<Recipient>;
    /**
     * 
     * @type {ISignatureType}
     * @memberof Bundle
     */
    'signatureType': ISignatureType;
    /**
     * expiration date for bundle
     * @type {string}
     * @memberof Bundle
     */
    'expirationDate': string;
    /**
     * Events subscribed for callback url (e.g. CREATED,EXPIRED,SIGNED)
     * @type {Array<string>}
     * @memberof Bundle
     */
    'callbackEvents'?: Array<string>;
    /**
     * callback url invoked for each event subscribed from the request
     * @type {string}
     * @memberof Bundle
     */
    'callbackUrl'?: string;
    /**
     * redirect url executed after frontend signature action completed
     * @type {string}
     * @memberof Bundle
     */
    'redirectUrl'?: string;
    /**
     * if true archive document to long term digital preservation
     * @type {boolean}
     * @memberof Bundle
     */
    'trustArchive': boolean;
}
/**
 * 
 * @export
 * @interface BundleFilterRequest
 */
export interface BundleFilterRequest {
    /**
     * filter to recipient ndg
     * @type {string}
     * @memberof BundleFilterRequest
     */
    'recipient'?: string;
    /**
     * list of recipient status to filter
     * @type {Array<string>}
     * @memberof BundleFilterRequest
     */
    'recipientStatus'?: Array<BundleFilterRequestRecipientStatusEnum>;
    /**
     * filter to recipient role
     * @type {string}
     * @memberof BundleFilterRequest
     */
    'recipientRole'?: BundleFilterRequestRecipientRoleEnum;
    /**
     * 
     * @type {Paginator}
     * @memberof BundleFilterRequest
     */
    'paginator'?: Paginator;
}

export const BundleFilterRequestRecipientStatusEnum = {
    ToNotify: 'TO_NOTIFY',
    NotifiedToSign: 'NOTIFIED_TO_SIGN',
    Signed: 'SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type BundleFilterRequestRecipientStatusEnum = typeof BundleFilterRequestRecipientStatusEnum[keyof typeof BundleFilterRequestRecipientStatusEnum];
export const BundleFilterRequestRecipientRoleEnum = {
    Signer: 'SIGNER',
    Cc: 'CC',
    Bcc: 'BCC'
} as const;

export type BundleFilterRequestRecipientRoleEnum = typeof BundleFilterRequestRecipientRoleEnum[keyof typeof BundleFilterRequestRecipientRoleEnum];

/**
 * 
 * @export
 * @interface BundleSearchRequest
 */
export interface BundleSearchRequest {
    /**
     * list of bundle status to filter
     * @type {Array<string>}
     * @memberof BundleSearchRequest
     */
    'bundleStatus'?: Array<BundleSearchRequestBundleStatusEnum>;
    /**
     * filter for agent code
     * @type {string}
     * @memberof BundleSearchRequest
     */
    'agentCode'?: string;
    /**
     * filter for recipient ndg
     * @type {string}
     * @memberof BundleSearchRequest
     */
    'recipient'?: string;
    /**
     * filter for source
     * @type {string}
     * @memberof BundleSearchRequest
     */
    'source'?: string;
    /**
     * list of recipient status to filter
     * @type {Array<string>}
     * @memberof BundleSearchRequest
     */
    'recipientStatus'?: Array<BundleSearchRequestRecipientStatusEnum>;
    /**
     * filter for recipient role
     * @type {string}
     * @memberof BundleSearchRequest
     */
    'recipientRole'?: BundleSearchRequestRecipientRoleEnum;
    /**
     * Filter for bundles close to expiring
     * @type {boolean}
     * @memberof BundleSearchRequest
     */
    'isExpiring'?: boolean;
    /**
     * filter for bundle creation date from
     * @type {string}
     * @memberof BundleSearchRequest
     */
    'fromCreationDate'?: string;
    /**
     * filter for bundle creation date to
     * @type {string}
     * @memberof BundleSearchRequest
     */
    'toCreationDate'?: string;
    /**
     * 
     * @type {Paginator}
     * @memberof BundleSearchRequest
     */
    'paginator'?: Paginator;
}

export const BundleSearchRequestBundleStatusEnum = {
    Inserted: 'INSERTED',
    Created: 'CREATED',
    CreationError: 'CREATION_ERROR',
    Signing: 'SIGNING',
    Signed: 'SIGNED',
    Downloading: 'DOWNLOADING',
    Downloaded: 'DOWNLOADED',
    DownloadingRejected: 'DOWNLOADING_REJECTED',
    ArchivingSigned: 'ARCHIVING_SIGNED',
    ArchivedSigned: 'ARCHIVED_SIGNED',
    SendingBo: 'SENDING_BO',
    SentBo: 'SENT_BO',
    NotifyingSigned: 'NOTIFYING_SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    Completed: 'COMPLETED',
    UpdatingDocuments: 'UPDATING_DOCUMENTS',
    UpdatingDocumentsExpired: 'UPDATING_DOCUMENTS_EXPIRED',
    UpdatedDocuments: 'UPDATED_DOCUMENTS',
    UpdatedDocumentsExpired: 'UPDATED_DOCUMENTS_EXPIRED',
    Expiring: 'EXPIRING',
    Expired: 'EXPIRED',
    DownloadingExpired: 'DOWNLOADING_EXPIRED',
    DownloadedExpired: 'DOWNLOADED_EXPIRED',
    DownloadedRejected: 'DOWNLOADED_REJECTED',
    ArchivingExpired: 'ARCHIVING_EXPIRED',
    ArchivedExpired: 'ARCHIVED_EXPIRED',
    NotifyingExpired: 'NOTIFYING_EXPIRED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    Retiring: 'RETIRING',
    Retired: 'RETIRED',
    CompletedRetired: 'COMPLETED_RETIRED',
    CompletedRejected: 'COMPLETED_REJECTED',
    CompletedExpired: 'COMPLETED_EXPIRED',
    NotifyingRetired: 'NOTIFYING_RETIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    Rejecting: 'REJECTING',
    ArchivingRejected: 'ARCHIVING_REJECTED',
    ArchivedRejected: 'ARCHIVED_REJECTED',
    NotifyingRejected: 'NOTIFYING_REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Finalizing: 'FINALIZING',
    Finalized: 'FINALIZED'
} as const;

export type BundleSearchRequestBundleStatusEnum = typeof BundleSearchRequestBundleStatusEnum[keyof typeof BundleSearchRequestBundleStatusEnum];
export const BundleSearchRequestRecipientStatusEnum = {
    ToNotify: 'TO_NOTIFY',
    NotifiedToSign: 'NOTIFIED_TO_SIGN',
    Signed: 'SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type BundleSearchRequestRecipientStatusEnum = typeof BundleSearchRequestRecipientStatusEnum[keyof typeof BundleSearchRequestRecipientStatusEnum];
export const BundleSearchRequestRecipientRoleEnum = {
    Signer: 'SIGNER',
    Cc: 'CC',
    Bcc: 'BCC'
} as const;

export type BundleSearchRequestRecipientRoleEnum = typeof BundleSearchRequestRecipientRoleEnum[keyof typeof BundleSearchRequestRecipientRoleEnum];

/**
 * 
 * @export
 * @interface BundleState
 */
export interface BundleState {
    /**
     * bundle code
     * @type {string}
     * @memberof BundleState
     */
    'bundleId'?: string;
    /**
     * bundle source system or flow
     * @type {string}
     * @memberof BundleState
     */
    'source'?: string;
    /**
     * bundle external id
     * @type {string}
     * @memberof BundleState
     */
    'externalId'?: string;
    /**
     * transaction id associated to process
     * @type {string}
     * @memberof BundleState
     */
    'transactionId'?: string;
    /**
     * bundle status
     * @type {string}
     * @memberof BundleState
     */
    'bundleStatus'?: BundleStateBundleStatusEnum;
    /**
     * bundle status date updated
     * @type {string}
     * @memberof BundleState
     */
    'statusDate'?: string;
    /**
     * signature type
     * @type {string}
     * @memberof BundleState
     */
    'signatureTypeCode'?: string;
    /**
     * bundle creation date
     * @type {string}
     * @memberof BundleState
     */
    'creationDate'?: string;
    /**
     * bundle expiration date
     * @type {string}
     * @memberof BundleState
     */
    'expirationDate'?: string;
    /**
     * recipients associated to bundle
     * @type {Array<RecipientState>}
     * @memberof BundleState
     */
    'recipients'?: Array<RecipientState>;
    /**
     * documents contained in bundle
     * @type {Array<DocumentState>}
     * @memberof BundleState
     */
    'documents'?: Array<DocumentState>;
    /**
     * process type code
     * @type {string}
     * @memberof BundleState
     */
    'processTypeCode'?: string;
}

export const BundleStateBundleStatusEnum = {
    Inserted: 'INSERTED',
    Created: 'CREATED',
    CreationError: 'CREATION_ERROR',
    Signing: 'SIGNING',
    Signed: 'SIGNED',
    Downloading: 'DOWNLOADING',
    Downloaded: 'DOWNLOADED',
    DownloadingRejected: 'DOWNLOADING_REJECTED',
    ArchivingSigned: 'ARCHIVING_SIGNED',
    ArchivedSigned: 'ARCHIVED_SIGNED',
    SendingBo: 'SENDING_BO',
    SentBo: 'SENT_BO',
    NotifyingSigned: 'NOTIFYING_SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    Completed: 'COMPLETED',
    UpdatingDocuments: 'UPDATING_DOCUMENTS',
    UpdatingDocumentsExpired: 'UPDATING_DOCUMENTS_EXPIRED',
    UpdatedDocuments: 'UPDATED_DOCUMENTS',
    UpdatedDocumentsExpired: 'UPDATED_DOCUMENTS_EXPIRED',
    Expiring: 'EXPIRING',
    Expired: 'EXPIRED',
    DownloadingExpired: 'DOWNLOADING_EXPIRED',
    DownloadedExpired: 'DOWNLOADED_EXPIRED',
    DownloadedRejected: 'DOWNLOADED_REJECTED',
    ArchivingExpired: 'ARCHIVING_EXPIRED',
    ArchivedExpired: 'ARCHIVED_EXPIRED',
    NotifyingExpired: 'NOTIFYING_EXPIRED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    Retiring: 'RETIRING',
    Retired: 'RETIRED',
    CompletedRetired: 'COMPLETED_RETIRED',
    CompletedRejected: 'COMPLETED_REJECTED',
    CompletedExpired: 'COMPLETED_EXPIRED',
    NotifyingRetired: 'NOTIFYING_RETIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    Rejecting: 'REJECTING',
    ArchivingRejected: 'ARCHIVING_REJECTED',
    ArchivedRejected: 'ARCHIVED_REJECTED',
    NotifyingRejected: 'NOTIFYING_REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Finalizing: 'FINALIZING',
    Finalized: 'FINALIZED'
} as const;

export type BundleStateBundleStatusEnum = typeof BundleStateBundleStatusEnum[keyof typeof BundleStateBundleStatusEnum];

/**
 * certification document data
 * @export
 * @interface CertificateData
 */
export interface CertificateData {
    /**
     * residence country (e.g IT,EN)
     * @type {string}
     * @memberof CertificateData
     */
    'countryResidence': string;
    /**
     * CI=Identity Card, PT=Patent, PS=Passport
     * @type {string}
     * @memberof CertificateData
     */
    'documentType': string;
    /**
     * document number
     * @type {string}
     * @memberof CertificateData
     */
    'documentNumber': string;
    /**
     * document issued by
     * @type {string}
     * @memberof CertificateData
     */
    'documentIssuedBy': string;
    /**
     * document issued date
     * @type {string}
     * @memberof CertificateData
     */
    'documentIssuedOn': string;
    /**
     * document expiration date
     * @type {string}
     * @memberof CertificateData
     */
    'documentExpirationDate': string;
    /**
     * document identification country (e.g IT,EN)
     * @type {string}
     * @memberof CertificateData
     */
    'identificationCountry': string;
    /**
     * user tax code
     * @type {string}
     * @memberof CertificateData
     */
    'serialNumber': string;
}
/**
 * recipient contact data
 * @export
 * @interface ContactData
 */
export interface ContactData {
    /**
     * mobile phone number contact
     * @type {string}
     * @memberof ContactData
     */
    'phoneNumber': string;
    /**
     * e-mail contact
     * @type {string}
     * @memberof ContactData
     */
    'email': string;
}
/**
 * documents to sign
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * document id obtained from upload API
     * @type {string}
     * @memberof Document
     */
    'id': string;
    /**
     * document sign enabled
     * @type {boolean}
     * @memberof Document
     */
    'toSign': boolean;
    /**
     * if true archive document to long term digital preservation. Default is true
     * @type {boolean}
     * @memberof Document
     */
    'trustArchive'?: boolean;
    /**
     * recipient reference for document visibility
     * @type {Set<RecipientReference>}
     * @memberof Document
     */
    'recipients': Set<RecipientReference>;
    /**
     * weight for document signing order
     * @type {number}
     * @memberof Document
     */
    'documentOrder': number;
}
/**
 * documents contained in bundle
 * @export
 * @interface DocumentState
 */
export interface DocumentState {
    /**
     * document code
     * @type {string}
     * @memberof DocumentState
     */
    'documentCode'?: string;
    /**
     * document status
     * @type {string}
     * @memberof DocumentState
     */
    'documentStatus'?: DocumentStateDocumentStatusEnum;
    /**
     * document status update date
     * @type {string}
     * @memberof DocumentState
     */
    'statusDate'?: string;
    /**
     * document is to sign
     * @type {boolean}
     * @memberof DocumentState
     */
    'toSign'?: boolean;
}

export const DocumentStateDocumentStatusEnum = {
    Created: 'CREATED',
    Archiving: 'ARCHIVING',
    Archived: 'ARCHIVED',
    SendingBo: 'SENDING_BO',
    SentBo: 'SENT_BO',
    Updated: 'UPDATED',
    UpdatedExpired: 'UPDATED_EXPIRED',
    Retired: 'RETIRED',
    Rejected: 'REJECTED',
    UpdatedRejected: 'UPDATED_REJECTED',
    UpdatedRetired: 'UPDATED_RETIRED'
} as const;

export type DocumentStateDocumentStatusEnum = typeof DocumentStateDocumentStatusEnum[keyof typeof DocumentStateDocumentStatusEnum];

/**
 * 
 * @export
 * @interface DomainType
 */
export interface DomainType {
    /**
     * Domain code
     * @type {string}
     * @memberof DomainType
     */
    'code'?: string;
    /**
     * Localized label code
     * @type {string}
     * @memberof DomainType
     */
    'labelCode'?: string;
}
/**
 * 
 * @export
 * @interface GroupedBundleFilter
 */
export interface GroupedBundleFilter {
    /**
     * Filter for recipients codes 
     * @type {Array<string>}
     * @memberof GroupedBundleFilter
     */
    'recipientCodes'?: Array<string>;
    /**
     * Filter for process types 
     * @type {Array<string>}
     * @memberof GroupedBundleFilter
     */
    'processTypeFilter'?: Array<string>;
    /**
     * Filter for grouping
     * @type {string}
     * @memberof GroupedBundleFilter
     */
    'groupField'?: string;
    /**
     * Filter for agent Code
     * @type {string}
     * @memberof GroupedBundleFilter
     */
    'agentCode'?: string;
    /**
     * Filter for bundles close to expiring
     * @type {boolean}
     * @memberof GroupedBundleFilter
     */
    'isExpiring'?: boolean;
    /**
     * 
     * @type {Paginator}
     * @memberof GroupedBundleFilter
     */
    'paginator'?: Paginator;
    /**
     * Recipient status info
     * @type {Array<string>}
     * @memberof GroupedBundleFilter
     */
    'recipientStatus'?: Array<GroupedBundleFilterRecipientStatusEnum>;
    /**
     * Bundle status status info
     * @type {Array<string>}
     * @memberof GroupedBundleFilter
     */
    'bundleStatus'?: Array<GroupedBundleFilterBundleStatusEnum>;
    /**
     * Filter for searching bundles from a specified date
     * @type {string}
     * @memberof GroupedBundleFilter
     */
    'fromCreationDate'?: string;
    /**
     * Filter for searching bundles from to a specified date
     * @type {string}
     * @memberof GroupedBundleFilter
     */
    'toCreationDate'?: string;
}

export const GroupedBundleFilterRecipientStatusEnum = {
    ToNotify: 'TO_NOTIFY',
    NotifiedToSign: 'NOTIFIED_TO_SIGN',
    Signed: 'SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type GroupedBundleFilterRecipientStatusEnum = typeof GroupedBundleFilterRecipientStatusEnum[keyof typeof GroupedBundleFilterRecipientStatusEnum];
export const GroupedBundleFilterBundleStatusEnum = {
    Inserted: 'INSERTED',
    Created: 'CREATED',
    CreationError: 'CREATION_ERROR',
    Signing: 'SIGNING',
    Signed: 'SIGNED',
    Downloading: 'DOWNLOADING',
    Downloaded: 'DOWNLOADED',
    DownloadingRejected: 'DOWNLOADING_REJECTED',
    ArchivingSigned: 'ARCHIVING_SIGNED',
    ArchivedSigned: 'ARCHIVED_SIGNED',
    SendingBo: 'SENDING_BO',
    SentBo: 'SENT_BO',
    NotifyingSigned: 'NOTIFYING_SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    Completed: 'COMPLETED',
    UpdatingDocuments: 'UPDATING_DOCUMENTS',
    UpdatingDocumentsExpired: 'UPDATING_DOCUMENTS_EXPIRED',
    UpdatedDocuments: 'UPDATED_DOCUMENTS',
    UpdatedDocumentsExpired: 'UPDATED_DOCUMENTS_EXPIRED',
    Expiring: 'EXPIRING',
    Expired: 'EXPIRED',
    DownloadingExpired: 'DOWNLOADING_EXPIRED',
    DownloadedExpired: 'DOWNLOADED_EXPIRED',
    DownloadedRejected: 'DOWNLOADED_REJECTED',
    ArchivingExpired: 'ARCHIVING_EXPIRED',
    ArchivedExpired: 'ARCHIVED_EXPIRED',
    NotifyingExpired: 'NOTIFYING_EXPIRED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    Retiring: 'RETIRING',
    Retired: 'RETIRED',
    CompletedRetired: 'COMPLETED_RETIRED',
    CompletedRejected: 'COMPLETED_REJECTED',
    CompletedExpired: 'COMPLETED_EXPIRED',
    NotifyingRetired: 'NOTIFYING_RETIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    Rejecting: 'REJECTING',
    ArchivingRejected: 'ARCHIVING_REJECTED',
    ArchivedRejected: 'ARCHIVED_REJECTED',
    NotifyingRejected: 'NOTIFYING_REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Finalizing: 'FINALIZING',
    Finalized: 'FINALIZED'
} as const;

export type GroupedBundleFilterBundleStatusEnum = typeof GroupedBundleFilterBundleStatusEnum[keyof typeof GroupedBundleFilterBundleStatusEnum];

/**
 * 
 * @export
 * @interface GroupedBundleState
 */
export interface GroupedBundleState {
    /**
     * Bundle code
     * @type {string}
     * @memberof GroupedBundleState
     */
    'bundleCode'?: string;
    /**
     * Status of bundle
     * @type {string}
     * @memberof GroupedBundleState
     */
    'bundleStatus'?: GroupedBundleStateBundleStatusEnum;
    /**
     * Signature date
     * @type {string}
     * @memberof GroupedBundleState
     */
    'signDate'?: string;
    /**
     * Expiration date
     * @type {string}
     * @memberof GroupedBundleState
     */
    'expirationDate'?: string;
    /**
     * Bundle\'s documents
     * @type {Array<DocumentState>}
     * @memberof GroupedBundleState
     */
    'documents'?: Array<DocumentState>;
    /**
     * Process Type
     * @type {string}
     * @memberof GroupedBundleState
     */
    'processTypeCode'?: string;
}

export const GroupedBundleStateBundleStatusEnum = {
    Inserted: 'INSERTED',
    Created: 'CREATED',
    CreationError: 'CREATION_ERROR',
    Signing: 'SIGNING',
    Signed: 'SIGNED',
    Downloading: 'DOWNLOADING',
    Downloaded: 'DOWNLOADED',
    DownloadingRejected: 'DOWNLOADING_REJECTED',
    ArchivingSigned: 'ARCHIVING_SIGNED',
    ArchivedSigned: 'ARCHIVED_SIGNED',
    SendingBo: 'SENDING_BO',
    SentBo: 'SENT_BO',
    NotifyingSigned: 'NOTIFYING_SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    Completed: 'COMPLETED',
    UpdatingDocuments: 'UPDATING_DOCUMENTS',
    UpdatingDocumentsExpired: 'UPDATING_DOCUMENTS_EXPIRED',
    UpdatedDocuments: 'UPDATED_DOCUMENTS',
    UpdatedDocumentsExpired: 'UPDATED_DOCUMENTS_EXPIRED',
    Expiring: 'EXPIRING',
    Expired: 'EXPIRED',
    DownloadingExpired: 'DOWNLOADING_EXPIRED',
    DownloadedExpired: 'DOWNLOADED_EXPIRED',
    DownloadedRejected: 'DOWNLOADED_REJECTED',
    ArchivingExpired: 'ARCHIVING_EXPIRED',
    ArchivedExpired: 'ARCHIVED_EXPIRED',
    NotifyingExpired: 'NOTIFYING_EXPIRED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    Retiring: 'RETIRING',
    Retired: 'RETIRED',
    CompletedRetired: 'COMPLETED_RETIRED',
    CompletedRejected: 'COMPLETED_REJECTED',
    CompletedExpired: 'COMPLETED_EXPIRED',
    NotifyingRetired: 'NOTIFYING_RETIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    Rejecting: 'REJECTING',
    ArchivingRejected: 'ARCHIVING_REJECTED',
    ArchivedRejected: 'ARCHIVED_REJECTED',
    NotifyingRejected: 'NOTIFYING_REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Finalizing: 'FINALIZING',
    Finalized: 'FINALIZED'
} as const;

export type GroupedBundleStateBundleStatusEnum = typeof GroupedBundleStateBundleStatusEnum[keyof typeof GroupedBundleStateBundleStatusEnum];

/**
 * process type of the signature flow
 * @export
 * @enum {string}
 */

export const IProcessType = {
    AdesioneServizioSolidarietaAzFund: 'ADESIONE_SERVIZIO_SOLIDARIETA_AZ_FUND',
    AdesioneServizioSolidarietaAzIta: 'ADESIONE_SERVIZIO_SOLIDARIETA_AZ_ITA',
    AdesioneServiziDigitali: 'ADESIONE_SERVIZI_DIGITALI',
    AdvisorDocuments: 'ADVISOR_DOCUMENTS',
    Aml: 'AML',
    AperturaCdl: 'APERTURA_CDL',
    AperturaDepositoPirAlternative: 'APERTURA_DEPOSITO_PIR_ALTERNATIVE',
    AperturaServiziDiInvestimento: 'APERTURA_SERVIZI_DI_INVESTIMENTO',
    AzLifeRid: 'AZ_LIFE_RID',
    ConferimentoProcuraOrdinariaFondi: 'CONFERIMENTO_PROCURA_ORDINARIA_FONDI',
    ContactData: 'CONTACT_DATA',
    DistribuzioneDividendi: 'DISTRIBUZIONE_DIVIDENDI',
    DistribuzioneProventi: 'DISTRIBUZIONE_PROVENTI',
    FinancialPlacement: 'FINANCIAL_PLACEMENT',
    GpConferimentoProcuraOrdinaria: 'GP_CONFERIMENTO_PROCURA_ORDINARIA',
    LetteraIstruzionePirAlternative: 'LETTERA_ISTRUZIONE_PIR_ALTERNATIVE',
    Mifid: 'MIFID',
    ModificaDistribuzioneProventi: 'MODIFICA_DISTRIBUZIONE_PROVENTI',
    Mosaico: 'MOSAICO',
    Onboarding: 'ONBOARDING',
    OnboardingNuovoCliente: 'ONBOARDING_NUOVO_CLIENTE',
    PrelievoAValereSulServizioContoDepositoMax: 'PRELIEVO_A_VALERE_SUL_SERVIZIO_CONTO_DEPOSITO_MAX',
    Reboarding: 'REBOARDING',
    Rto: 'RTO',
    VersamentoAggiuntivoMax: 'VERSAMENTO_AGGIUNTIVO_MAX'
} as const;

export type IProcessType = typeof IProcessType[keyof typeof IProcessType];


/**
 * role of recipient
 * @export
 * @enum {string}
 */

export const IRecipientRole = {
    Bcc: 'BCC',
    Cc: 'CC',
    Signer: 'SIGNER'
} as const;

export type IRecipientRole = typeof IRecipientRole[keyof typeof IRecipientRole];


/**
 * type of recipient
 * @export
 * @enum {string}
 */

export const IRecipientUserType = {
    A: 'A',
    C: 'C'
} as const;

export type IRecipientUserType = typeof IRecipientUserType[keyof typeof IRecipientUserType];


/**
 * type of signature
 * @export
 * @enum {string}
 */

export const ISignatureType = {
    Feq: 'FEQ'
} as const;

export type ISignatureType = typeof ISignatureType[keyof typeof ISignatureType];


/**
 * 
 * @export
 * @interface InfoServiceBean
 */
export interface InfoServiceBean {
    /**
     * 
     * @type {string}
     * @memberof InfoServiceBean
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InfoServiceBean
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface MessageInfo
 */
export interface MessageInfo {
    /**
     * 
     * @type {number}
     * @memberof MessageInfo
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageInfo
     */
    'messageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageInfo
     */
    'timestamp'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MessageInfo
     */
    'headers'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof MessageInfo
     */
    'body'?: string;
}
/**
 * pagination info
 * @export
 * @interface Paginator
 */
export interface Paginator {
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'totalPageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof Paginator
     */
    'current'?: number;
    /**
     * 
     * @type {string}
     * @memberof Paginator
     */
    'orderType'?: PaginatorOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Paginator
     */
    'orderBy'?: string;
}

export const PaginatorOrderTypeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type PaginatorOrderTypeEnum = typeof PaginatorOrderTypeEnum[keyof typeof PaginatorOrderTypeEnum];

/**
 * 
 * @export
 * @interface PermissionServiceBean
 */
export interface PermissionServiceBean {
    /**
     * 
     * @type {string}
     * @memberof PermissionServiceBean
     */
    'name'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof PermissionServiceBean
     */
    'permissions'?: Set<string>;
}
/**
 * recipient personal data
 * @export
 * @interface PersonalData
 */
export interface PersonalData {
    /**
     * first name
     * @type {string}
     * @memberof PersonalData
     */
    'firstName': string;
    /**
     * last name
     * @type {string}
     * @memberof PersonalData
     */
    'lastName': string;
    /**
     * full name
     * @type {string}
     * @memberof PersonalData
     */
    'fullName': string;
    /**
     * birthdate
     * @type {string}
     * @memberof PersonalData
     */
    'dateOfBirth': string;
    /**
     * tax code
     * @type {string}
     * @memberof PersonalData
     */
    'taxCode': string;
}
/**
 * 
 * @export
 * @interface QueueInfo
 */
export interface QueueInfo {
    /**
     * 
     * @type {string}
     * @memberof QueueInfo
     */
    'queueName'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueueInfo
     */
    'messages'?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof QueueInfo
     */
    'queueArguments'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof QueueInfo
     */
    'moveTo'?: string;
}
/**
 * Recipients involved in sign process
 * @export
 * @interface Recipient
 */
export interface Recipient {
    /**
     * recipient user id
     * @type {string}
     * @memberof Recipient
     */
    'userId': string;
    /**
     * 
     * @type {IRecipientUserType}
     * @memberof Recipient
     */
    'userType': IRecipientUserType;
    /**
     * recipient user behalfOf id
     * @type {string}
     * @memberof Recipient
     */
    'userBehalfOfId'?: string;
    /**
     * 
     * @type {IRecipientUserType}
     * @memberof Recipient
     */
    'userBehalfOfType'?: IRecipientUserType;
    /**
     * recipients signature order
     * @type {number}
     * @memberof Recipient
     */
    'routingOrder': number;
    /**
     * 
     * @type {IRecipientRole}
     * @memberof Recipient
     */
    'role': IRecipientRole;
    /**
     * recipient preferred language (e.g. it,en)
     * @type {string}
     * @memberof Recipient
     */
    'language'?: string;
    /**
     * 
     * @type {ContactData}
     * @memberof Recipient
     */
    'contactData': ContactData;
    /**
     * 
     * @type {PersonalData}
     * @memberof Recipient
     */
    'personalData': PersonalData;
    /**
     * 
     * @type {CertificateData}
     * @memberof Recipient
     */
    'certificateData': CertificateData;
}
/**
 * recipient reference for document visibility
 * @export
 * @interface RecipientReference
 */
export interface RecipientReference {
    /**
     * recipient user id
     * @type {string}
     * @memberof RecipientReference
     */
    'userId': string;
    /**
     * 
     * @type {IRecipientUserType}
     * @memberof RecipientReference
     */
    'userType': IRecipientUserType;
    /**
     * recipient user behalfOf id
     * @type {string}
     * @memberof RecipientReference
     */
    'userBehalfOfId'?: string;
    /**
     * 
     * @type {IRecipientUserType}
     * @memberof RecipientReference
     */
    'userBehalfOfType'?: IRecipientUserType;
}
/**
 * recipients associated to bundle
 * @export
 * @interface RecipientState
 */
export interface RecipientState {
    /**
     * recipient user id
     * @type {string}
     * @memberof RecipientState
     */
    'userId'?: string;
    /**
     * recipient user type
     * @type {string}
     * @memberof RecipientState
     */
    'userType'?: string;
    /**
     * recipient role type
     * @type {string}
     * @memberof RecipientState
     */
    'roleTypeCode'?: string;
    /**
     * recipient sign order
     * @type {number}
     * @memberof RecipientState
     */
    'routingOrder'?: number;
    /**
     * recipient status
     * @type {string}
     * @memberof RecipientState
     */
    'recipientStatus'?: RecipientStateRecipientStatusEnum;
    /**
     * recipient status date updated
     * @type {string}
     * @memberof RecipientState
     */
    'statusDate'?: string;
    /**
     * recipient preferred language
     * @type {string}
     * @memberof RecipientState
     */
    'language'?: string;
    /**
     * recipient full name
     * @type {string}
     * @memberof RecipientState
     */
    'recipientFullName'?: string;
    /**
     * recipient user behalf of id
     * @type {string}
     * @memberof RecipientState
     */
    'userBehalfOfId'?: string;
    /**
     * recipient user behalf of type
     * @type {string}
     * @memberof RecipientState
     */
    'userBehalfOfType'?: string;
}

export const RecipientStateRecipientStatusEnum = {
    ToNotify: 'TO_NOTIFY',
    NotifiedToSign: 'NOTIFIED_TO_SIGN',
    Signed: 'SIGNED',
    NotifiedSigned: 'NOTIFIED_SIGNED',
    NotifiedExpired: 'NOTIFIED_EXPIRED',
    NotifiedRetired: 'NOTIFIED_RETIRED',
    Rejected: 'REJECTED',
    NotifiedRejected: 'NOTIFIED_REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type RecipientStateRecipientStatusEnum = typeof RecipientStateRecipientStatusEnum[keyof typeof RecipientStateRecipientStatusEnum];

/**
 * 
 * @export
 * @interface RejectBundleRequest
 */
export interface RejectBundleRequest {
    /**
     * bundle code to retire
     * @type {string}
     * @memberof RejectBundleRequest
     */
    'bundleCode': string;
    /**
     * customer code that perform reject action
     * @type {string}
     * @memberof RejectBundleRequest
     */
    'customerCode': string;
}
/**
 * 
 * @export
 * @interface ResourceIdentifier
 */
export interface ResourceIdentifier {
    /**
     * code of the bundle created
     * @type {string}
     * @memberof ResourceIdentifier
     */
    'bundleCode'?: string;
    /**
     * transaction id associated with the signature process flow started
     * @type {string}
     * @memberof ResourceIdentifier
     */
    'transactionId'?: string;
}
/**
 * 
 * @export
 * @interface ResponseBoolean
 */
export interface ResponseBoolean {
    /**
     * 
     * @type {string}
     * @memberof ResponseBoolean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseBoolean
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseBoolean
     */
    'result'?: boolean;
}
/**
 * 
 * @export
 * @interface ResponseBundleState
 */
export interface ResponseBundleState {
    /**
     * 
     * @type {string}
     * @memberof ResponseBundleState
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseBundleState
     */
    'message'?: string;
    /**
     * 
     * @type {BundleState}
     * @memberof ResponseBundleState
     */
    'result'?: BundleState;
}
/**
 * 
 * @export
 * @interface ResponseInfoServiceBean
 */
export interface ResponseInfoServiceBean {
    /**
     * 
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseInfoServiceBean
     */
    'message'?: string;
    /**
     * 
     * @type {InfoServiceBean}
     * @memberof ResponseInfoServiceBean
     */
    'result'?: InfoServiceBean;
}
/**
 * 
 * @export
 * @interface ResponseListDomainType
 */
export interface ResponseListDomainType {
    /**
     * 
     * @type {string}
     * @memberof ResponseListDomainType
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListDomainType
     */
    'message'?: string;
    /**
     * 
     * @type {Array<DomainType>}
     * @memberof ResponseListDomainType
     */
    'result'?: Array<DomainType>;
}
/**
 * 
 * @export
 * @interface ResponseListMessageInfo
 */
export interface ResponseListMessageInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponseListMessageInfo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListMessageInfo
     */
    'message'?: string;
    /**
     * 
     * @type {Array<MessageInfo>}
     * @memberof ResponseListMessageInfo
     */
    'result'?: Array<MessageInfo>;
}
/**
 * 
 * @export
 * @interface ResponseListQueueInfo
 */
export interface ResponseListQueueInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponseListQueueInfo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListQueueInfo
     */
    'message'?: string;
    /**
     * 
     * @type {Array<QueueInfo>}
     * @memberof ResponseListQueueInfo
     */
    'result'?: Array<QueueInfo>;
}
/**
 * 
 * @export
 * @interface ResponseListString
 */
export interface ResponseListString {
    /**
     * 
     * @type {string}
     * @memberof ResponseListString
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseListString
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseListString
     */
    'result'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResponseLong
 */
export interface ResponseLong {
    /**
     * 
     * @type {string}
     * @memberof ResponseLong
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseLong
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseLong
     */
    'result'?: number;
}
/**
 * 
 * @export
 * @interface ResponsePaginatedListBundleState
 */
export interface ResponsePaginatedListBundleState {
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedListBundleState
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedListBundleState
     */
    'message'?: string;
    /**
     * 
     * @type {Array<BundleState>}
     * @memberof ResponsePaginatedListBundleState
     */
    'result'?: Array<BundleState>;
    /**
     * 
     * @type {Paginator}
     * @memberof ResponsePaginatedListBundleState
     */
    'paginator'?: Paginator;
}
/**
 * 
 * @export
 * @interface ResponsePaginatedMapStringListGroupedBundleState
 */
export interface ResponsePaginatedMapStringListGroupedBundleState {
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedMapStringListGroupedBundleState
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePaginatedMapStringListGroupedBundleState
     */
    'message'?: string;
    /**
     * 
     * @type {{ [key: string]: Array<GroupedBundleState>; }}
     * @memberof ResponsePaginatedMapStringListGroupedBundleState
     */
    'result'?: { [key: string]: Array<GroupedBundleState>; };
    /**
     * 
     * @type {Paginator}
     * @memberof ResponsePaginatedMapStringListGroupedBundleState
     */
    'paginator'?: Paginator;
}
/**
 * 
 * @export
 * @interface ResponsePermissionServiceBean
 */
export interface ResponsePermissionServiceBean {
    /**
     * 
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePermissionServiceBean
     */
    'message'?: string;
    /**
     * 
     * @type {PermissionServiceBean}
     * @memberof ResponsePermissionServiceBean
     */
    'result'?: PermissionServiceBean;
}
/**
 * 
 * @export
 * @interface ResponseResourceIdentifier
 */
export interface ResponseResourceIdentifier {
    /**
     * 
     * @type {string}
     * @memberof ResponseResourceIdentifier
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseResourceIdentifier
     */
    'message'?: string;
    /**
     * 
     * @type {ResourceIdentifier}
     * @memberof ResponseResourceIdentifier
     */
    'result'?: ResourceIdentifier;
}
/**
 * 
 * @export
 * @interface ResponseString
 */
export interface ResponseString {
    /**
     * 
     * @type {string}
     * @memberof ResponseString
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseString
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseString
     */
    'result'?: string;
}
/**
 * 
 * @export
 * @interface ResponseVoid
 */
export interface ResponseVoid {
    /**
     * 
     * @type {string}
     * @memberof ResponseVoid
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseVoid
     */
    'message'?: string;
    /**
     * 
     * @type {object}
     * @memberof ResponseVoid
     */
    'result'?: object;
}
/**
 * 
 * @export
 * @interface RetireBundleRequest
 */
export interface RetireBundleRequest {
    /**
     * bundle code to retire
     * @type {string}
     * @memberof RetireBundleRequest
     */
    'bundleCode': string;
    /**
     * agent code that perform retire action
     * @type {string}
     * @memberof RetireBundleRequest
     */
    'agentCode': string;
}

/**
 * InfoProviderApi - axios parameter creator
 * @export
 */
export const InfoProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/digital-sign-signroom/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoProviderApi - functional programming interface
 * @export
 */
export const InfoProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async info1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseInfoServiceBean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.info1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InfoProviderApi - factory interface
 * @export
 */
export const InfoProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoProviderApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info1(options?: any): AxiosPromise<ResponseInfoServiceBean> {
            return localVarFp.info1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoProviderApi - object-oriented interface
 * @export
 * @class InfoProviderApi
 * @extends {BaseAPI}
 */
export class InfoProviderApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoProviderApi
     */
    public info1(options?: AxiosRequestConfig) {
        return InfoProviderApiFp(this.configuration).info1(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SignroomProviderApi - axios parameter creator
 * @export
 */
export const SignroomProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * bundle contains document reference from documentUpload API on DsDigitalSignUploadDocumentProvider
         * @summary Create bundle to start signature process
         * @param {Bundle} [bundle] Bundle is composed of a set of documents and a set of subscribers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBundle1: async (bundle?: Bundle, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/digital-sign-signroom/signroom/createBundle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bundle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve bundle state
         * @param {string} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleState1: async (bundleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundleId' is not null or undefined
            assertParamExists('getBundleState1', 'bundleId', bundleId)
            const localVarPath = `/digital-sign-signroom/signroom/bundle/{bundleId}`
                .replace(`{${"bundleId"}}`, encodeURIComponent(String(bundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve bundle url for signature. This API must be called for each recipient that must sign. UserCode and, if present, userBehalfOfCode are used to identify the recipient specified in createBundle.
         * @param {string} bundleId bundle code
         * @param {string} recipient the recipient userCode that wants to sign
         * @param {string} [userBehalfOfCode] the recipient userBehalfOfCode that wants to sign
         * @param {boolean} [behalf] flag for customer behalf of code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleUrl1: async (bundleId: string, recipient: string, userBehalfOfCode?: string, behalf?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bundleId' is not null or undefined
            assertParamExists('getBundleUrl1', 'bundleId', bundleId)
            // verify required parameter 'recipient' is not null or undefined
            assertParamExists('getBundleUrl1', 'recipient', recipient)
            const localVarPath = `/digital-sign-signroom/signroom/bundle/{bundleId}/url`
                .replace(`{${"bundleId"}}`, encodeURIComponent(String(bundleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (recipient !== undefined) {
                localVarQueryParameter['recipient'] = recipient;
            }

            if (userBehalfOfCode !== undefined) {
                localVarQueryParameter['userBehalfOfCode'] = userBehalfOfCode;
            }

            if (behalf !== undefined) {
                localVarQueryParameter['behalf'] = behalf;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Perform reject bundle action
         * @param {RejectBundleRequest} [rejectBundleRequest] reject request params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectBundle1: async (rejectBundleRequest?: RejectBundleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/digital-sign-signroom/signroom/bundle/reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectBundleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Perform retire bundle action
         * @param {RetireBundleRequest} [retireBundleRequest] retire request params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retireBundle1: async (retireBundleRequest?: RetireBundleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/digital-sign-signroom/signroom/bundle/retire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retireBundleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search bundle by filters
         * @param {boolean} [behalf] flag for customer behalf of code
         * @param {BundleSearchRequest} [bundleSearchRequest] Filter to retrieve a list of bundle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBundles1: async (behalf?: boolean, bundleSearchRequest?: BundleSearchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/digital-sign-signroom/signroom/bundle/search?behalf={behalf}`
                .replace(`{${"behalf"}}`, encodeURIComponent(String(behalf)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bundleSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignroomProviderApi - functional programming interface
 * @export
 */
export const SignroomProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignroomProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * bundle contains document reference from documentUpload API on DsDigitalSignUploadDocumentProvider
         * @summary Create bundle to start signature process
         * @param {Bundle} [bundle] Bundle is composed of a set of documents and a set of subscribers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBundle1(bundle?: Bundle, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseResourceIdentifier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBundle1(bundle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve bundle state
         * @param {string} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBundleState1(bundleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseBundleState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBundleState1(bundleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve bundle url for signature. This API must be called for each recipient that must sign. UserCode and, if present, userBehalfOfCode are used to identify the recipient specified in createBundle.
         * @param {string} bundleId bundle code
         * @param {string} recipient the recipient userCode that wants to sign
         * @param {string} [userBehalfOfCode] the recipient userBehalfOfCode that wants to sign
         * @param {boolean} [behalf] flag for customer behalf of code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBundleUrl1(bundleId: string, recipient: string, userBehalfOfCode?: string, behalf?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBundleUrl1(bundleId, recipient, userBehalfOfCode, behalf, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Perform reject bundle action
         * @param {RejectBundleRequest} [rejectBundleRequest] reject request params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectBundle1(rejectBundleRequest?: RejectBundleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectBundle1(rejectBundleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Perform retire bundle action
         * @param {RetireBundleRequest} [retireBundleRequest] retire request params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retireBundle1(retireBundleRequest?: RetireBundleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retireBundle1(retireBundleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search bundle by filters
         * @param {boolean} [behalf] flag for customer behalf of code
         * @param {BundleSearchRequest} [bundleSearchRequest] Filter to retrieve a list of bundle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchBundles1(behalf?: boolean, bundleSearchRequest?: BundleSearchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePaginatedListBundleState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchBundles1(behalf, bundleSearchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SignroomProviderApi - factory interface
 * @export
 */
export const SignroomProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignroomProviderApiFp(configuration)
    return {
        /**
         * bundle contains document reference from documentUpload API on DsDigitalSignUploadDocumentProvider
         * @summary Create bundle to start signature process
         * @param {Bundle} [bundle] Bundle is composed of a set of documents and a set of subscribers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBundle1(bundle?: Bundle, options?: any): AxiosPromise<ResponseResourceIdentifier> {
            return localVarFp.createBundle1(bundle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve bundle state
         * @param {string} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleState1(bundleId: string, options?: any): AxiosPromise<ResponseBundleState> {
            return localVarFp.getBundleState1(bundleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve bundle url for signature. This API must be called for each recipient that must sign. UserCode and, if present, userBehalfOfCode are used to identify the recipient specified in createBundle.
         * @param {string} bundleId bundle code
         * @param {string} recipient the recipient userCode that wants to sign
         * @param {string} [userBehalfOfCode] the recipient userBehalfOfCode that wants to sign
         * @param {boolean} [behalf] flag for customer behalf of code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundleUrl1(bundleId: string, recipient: string, userBehalfOfCode?: string, behalf?: boolean, options?: any): AxiosPromise<ResponseString> {
            return localVarFp.getBundleUrl1(bundleId, recipient, userBehalfOfCode, behalf, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Perform reject bundle action
         * @param {RejectBundleRequest} [rejectBundleRequest] reject request params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectBundle1(rejectBundleRequest?: RejectBundleRequest, options?: any): AxiosPromise<ResponseString> {
            return localVarFp.rejectBundle1(rejectBundleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Perform retire bundle action
         * @param {RetireBundleRequest} [retireBundleRequest] retire request params
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retireBundle1(retireBundleRequest?: RetireBundleRequest, options?: any): AxiosPromise<ResponseString> {
            return localVarFp.retireBundle1(retireBundleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search bundle by filters
         * @param {boolean} [behalf] flag for customer behalf of code
         * @param {BundleSearchRequest} [bundleSearchRequest] Filter to retrieve a list of bundle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchBundles1(behalf?: boolean, bundleSearchRequest?: BundleSearchRequest, options?: any): AxiosPromise<ResponsePaginatedListBundleState> {
            return localVarFp.searchBundles1(behalf, bundleSearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createBundle1 operation in SignroomProviderApi.
 * @export
 * @interface SignroomProviderApiCreateBundle1Request
 */
export interface SignroomProviderApiCreateBundle1Request {
    /**
     * Bundle is composed of a set of documents and a set of subscribers
     * @type {Bundle}
     * @memberof SignroomProviderApiCreateBundle1
     */
    readonly bundle?: Bundle
}

/**
 * Request parameters for getBundleState1 operation in SignroomProviderApi.
 * @export
 * @interface SignroomProviderApiGetBundleState1Request
 */
export interface SignroomProviderApiGetBundleState1Request {
    /**
     * 
     * @type {string}
     * @memberof SignroomProviderApiGetBundleState1
     */
    readonly bundleId: string
}

/**
 * Request parameters for getBundleUrl1 operation in SignroomProviderApi.
 * @export
 * @interface SignroomProviderApiGetBundleUrl1Request
 */
export interface SignroomProviderApiGetBundleUrl1Request {
    /**
     * bundle code
     * @type {string}
     * @memberof SignroomProviderApiGetBundleUrl1
     */
    readonly bundleId: string

    /**
     * the recipient userCode that wants to sign
     * @type {string}
     * @memberof SignroomProviderApiGetBundleUrl1
     */
    readonly recipient: string

    /**
     * the recipient userBehalfOfCode that wants to sign
     * @type {string}
     * @memberof SignroomProviderApiGetBundleUrl1
     */
    readonly userBehalfOfCode?: string

    /**
     * flag for customer behalf of code
     * @type {boolean}
     * @memberof SignroomProviderApiGetBundleUrl1
     */
    readonly behalf?: boolean
}

/**
 * Request parameters for rejectBundle1 operation in SignroomProviderApi.
 * @export
 * @interface SignroomProviderApiRejectBundle1Request
 */
export interface SignroomProviderApiRejectBundle1Request {
    /**
     * reject request params
     * @type {RejectBundleRequest}
     * @memberof SignroomProviderApiRejectBundle1
     */
    readonly rejectBundleRequest?: RejectBundleRequest
}

/**
 * Request parameters for retireBundle1 operation in SignroomProviderApi.
 * @export
 * @interface SignroomProviderApiRetireBundle1Request
 */
export interface SignroomProviderApiRetireBundle1Request {
    /**
     * retire request params
     * @type {RetireBundleRequest}
     * @memberof SignroomProviderApiRetireBundle1
     */
    readonly retireBundleRequest?: RetireBundleRequest
}

/**
 * Request parameters for searchBundles1 operation in SignroomProviderApi.
 * @export
 * @interface SignroomProviderApiSearchBundles1Request
 */
export interface SignroomProviderApiSearchBundles1Request {
    /**
     * flag for customer behalf of code
     * @type {boolean}
     * @memberof SignroomProviderApiSearchBundles1
     */
    readonly behalf?: boolean

    /**
     * Filter to retrieve a list of bundle
     * @type {BundleSearchRequest}
     * @memberof SignroomProviderApiSearchBundles1
     */
    readonly bundleSearchRequest?: BundleSearchRequest
}

/**
 * SignroomProviderApi - object-oriented interface
 * @export
 * @class SignroomProviderApi
 * @extends {BaseAPI}
 */
export class SignroomProviderApi extends BaseAPI {
    /**
     * bundle contains document reference from documentUpload API on DsDigitalSignUploadDocumentProvider
     * @summary Create bundle to start signature process
     * @param {SignroomProviderApiCreateBundle1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomProviderApi
     */
    public createBundle1(requestParameters: SignroomProviderApiCreateBundle1Request = {}, options?: AxiosRequestConfig) {
        return SignroomProviderApiFp(this.configuration).createBundle1(requestParameters.bundle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve bundle state
     * @param {SignroomProviderApiGetBundleState1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomProviderApi
     */
    public getBundleState1(requestParameters: SignroomProviderApiGetBundleState1Request, options?: AxiosRequestConfig) {
        return SignroomProviderApiFp(this.configuration).getBundleState1(requestParameters.bundleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve bundle url for signature. This API must be called for each recipient that must sign. UserCode and, if present, userBehalfOfCode are used to identify the recipient specified in createBundle.
     * @param {SignroomProviderApiGetBundleUrl1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomProviderApi
     */
    public getBundleUrl1(requestParameters: SignroomProviderApiGetBundleUrl1Request, options?: AxiosRequestConfig) {
        return SignroomProviderApiFp(this.configuration).getBundleUrl1(requestParameters.bundleId, requestParameters.recipient, requestParameters.userBehalfOfCode, requestParameters.behalf, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Perform reject bundle action
     * @param {SignroomProviderApiRejectBundle1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomProviderApi
     */
    public rejectBundle1(requestParameters: SignroomProviderApiRejectBundle1Request = {}, options?: AxiosRequestConfig) {
        return SignroomProviderApiFp(this.configuration).rejectBundle1(requestParameters.rejectBundleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Perform retire bundle action
     * @param {SignroomProviderApiRetireBundle1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomProviderApi
     */
    public retireBundle1(requestParameters: SignroomProviderApiRetireBundle1Request = {}, options?: AxiosRequestConfig) {
        return SignroomProviderApiFp(this.configuration).retireBundle1(requestParameters.retireBundleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search bundle by filters
     * @param {SignroomProviderApiSearchBundles1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignroomProviderApi
     */
    public searchBundles1(requestParameters: SignroomProviderApiSearchBundles1Request = {}, options?: AxiosRequestConfig) {
        return SignroomProviderApiFp(this.configuration).searchBundles1(requestParameters.behalf, requestParameters.bundleSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


